import { useState, type FormEvent } from "react";

import type { CreateTenantPayload } from "@/api/tenants";
import { Button, Ribbon } from "@/components/ui";
import { t } from "@/i18n";

interface CreateTenantFormProps {
  onSubmit: (payload: CreateTenantPayload) => void;
  isSubmitting: boolean;
  error: string | null;
  success: boolean;
}

/** "Tenant oluştur" formu — /admin (gorev talimati madde 5). Platform
 * OLUSTURMADAN SONRA degistirilemez (backend UpdateTenantRequest'te alan
 * yok) — bu yuzden burada seciliyor, /kurulum'da salt-okunur gosteriliyor. */
export function CreateTenantForm({ onSubmit, isSubmitting, error, success }: CreateTenantFormProps) {
  const [slug, setSlug] = useState("");
  const [name, setName] = useState("");
  const [platform, setPlatform] = useState<"ticimax" | "ikas" | "ideasoft" | "shopify">("ticimax");
  const [storeUrl, setStoreUrl] = useState("");

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!slug.trim() || !name.trim()) return;
    onSubmit({
      slug: slug.trim(),
      name: name.trim(),
      platform,
      ...(storeUrl.trim() ? { store_url: storeUrl.trim() } : {}),
    });
  }

  return (
    <form onSubmit={handleSubmit} className="card space-y-3">
      <h2 className="text-sm font-bold uppercase tracking-wide text-muted">{t("admin.tenants.create")}</h2>

      {error && <Ribbon tone="bad">{error}</Ribbon>}
      {success && <Ribbon tone="ok">{t("admin.create.success")}</Ribbon>}

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <label className="block">
          <span className="label">{t("admin.tenants.slug")}</span>
          <input required value={slug} onChange={(e) => setSlug(e.target.value)} className="input" />
        </label>
        <label className="block">
          <span className="label">{t("admin.tenants.name")}</span>
          <input required value={name} onChange={(e) => setName(e.target.value)} className="input" />
        </label>
        <label className="block">
          <span className="label">{t("admin.tenants.platform")}</span>
          <select
            value={platform}
            onChange={(e) => setPlatform(e.target.value as "ticimax" | "ikas" | "ideasoft" | "shopify")}
            className="input"
          >
            <option value="ticimax">{t("kurulum.platform.ticimax")}</option>
            <option value="ikas">{t("kurulum.platform.ikas")}</option>
            <option value="shopify">Shopify</option>
            <option value="ideasoft">{t("kurulum.platform.ideasoft")}</option>
          </select>
        </label>
        <label className="block">
          <span className="label">{t("kurulum.platform.store_url")}</span>
          <input value={storeUrl} onChange={(e) => setStoreUrl(e.target.value)} className="input" />
        </label>
      </div>

      <Button type="submit" variant="primary" disabled={isSubmitting}>
        {t("admin.create.submit")}
      </Button>
    </form>
  );
}
